class FieldsStore {
  constructor() {
    this.fields = [];
    this.listeners = [];
  }

  setFields(fields) {
    this.fields = fields;
    this.notify();
  }

  getFields() {
    return this.fields;
  }

  addField(field) {
    this.fields.push(field);
    this.notify();
  }

  subscribe(listener) {
    this.listeners.push(listener);
  }

  unsubscribe(listener) {
    this.listeners = this.listeners.filter(l => l !== listener);
  }

  notify() {
      this.listeners.forEach(listener => listener(this.fields));

  }
}

const instance = new FieldsStore();
export default instance;